import { h } from "preact";
var userActionRequiredStyles = {
    color: "#b9292b",
};
var noUserActionStyles = {
    color: "#777",
};
/**
 * Show a message indicating to the user that he should do something to fix it
 */
export var UserActionRequiredMessage = function (_a) {
    var message = _a.message;
    return (h("div", { style: userActionRequiredStyles }, message));
};
/**
 * Show a message to the user indicating that there is nothing he can do
 */
export var NoUserActionMessage = function (_a) {
    var message = _a.message;
    return (h("div", { style: noUserActionStyles }, message));
};
/**
 * Indicates that the user should authenticate (probably by refreshing its page)
 */
export var AuthenticationRequiredMessage = function () { return (h(UserActionRequiredMessage, { message: "Authentication required" })); };
/**
 * Indicates that the user should select some data elsewhere in the page
 */
export var SelectDataMessage = function () { return (h(UserActionRequiredMessage, { message: "Select data" })); };
/**
 * Indicates that no useful data could be retrieved
 */
export var NoResultMessage = function () { return (h(NoUserActionMessage, { message: "No result" })); };
/**
 * Indicates that an error occured on the server
 */
export var ServerErrorMessage = function () { return (h(NoUserActionMessage, { message: "Server error" })); };
/**
 * An animated loading indicator to use when performing API calls for example
 */
export var LoadingIndicatorMessage = function () {
    return (h("div", { style: {
            alignItems: "center",
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
        } },
        h("div", null,
            h("i", { className: "fa fa-spinner fa-pulse fa-2x fa-fw", style: { color: "#777" } }))));
};
